import React from "react";
import "./Hub.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import hh from "../../images/hub-img.webp";
import cc from "../../images/hub-card.webp";
import gg from "../../images/gift-green.svg";

function Hub() {
  return (
    <div className="hub-main">
      <div className="ques-main hub-cont-banner">
        <div className="container-fluid">
          <div className="row ques-row">
            <div className="col-12">
              <div className="ques-top">
                {/* dangerouslySetInnerHTML={{__html:pageDetail?.quiz_list_banner_content}} */}
                <div className="ques-top-title">
                  <h1> Your Core-64 Career Hub</h1>
                  <h3>
                    Discover Your Core-64 <span>Career Paths</span>
                  </h3>
                  <p>
                    Your personality pattern holds powerful clues about the work
                    you'll love and the impact you're here to make. Explore
                    careers aligned to your Core-64 archetype.
                  </p>

                  <div className="hub-banner-bnts">
                    <a href="" class="new-commom-btn homearche-explore">
                      <span>Explore 64 Archetype</span>

                      <span class="righ-arr">
                        <FontAwesomeIcon icon={faArrowRight} />
                      </span>
                    </a>
                    <a href="" class="new-commom-btn hub-banner-reveal">
                      <span>Reveal My Pattern</span>

                      <span class="righ-arr">
                        <FontAwesomeIcon icon={faArrowRight} />
                      </span>
                    </a>
                  </div>

                  <ul>
                    <li>✨ 2 min quiz</li>
                    <li>Instant insights</li>
                    <li>64 unique patterns</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hub-section">
        <div className="container">
          <div className="row hub-list-row">
            <div className="col-md-6">
              <div className="hub-list-div">
                <h2>What Your Career Pattern Reveals</h2>
                <p>
                  Your Core-64 pattern connects your natural strengths,
                  motivations, and energetic style to meaningful career paths.
                </p>

                <ul>
                  <li>
                    Clarity — Understand career paths that align with who you
                    are.
                  </li>
                  <li>
                    Direction — Find roles that fit your energy, values, and
                    ambitions.
                  </li>
                  <li>
                    Confidence — Make informed choices with self-trust and
                    purpose.
                  </li>
                  <li>
                    Growth — Unlock your potential and expand your
                    opportunities.
                  </li>
                  <li>
                    Fulfillment — Build a career that feels meaningful and
                    sustainable.
                  </li>
                </ul>

                <a href="" class="new-commom-btn hub-banner-reveal">
                  <span>Take the Free Personality Quiz</span>

                  <span class="righ-arr">
                    <FontAwesomeIcon icon={faArrowRight} />
                  </span>
                </a>
              </div>
            </div>

            <div className="col-md-6">
              <div className="hub-list-image">
                <img src={hh} alt="" />
              </div>
            </div>
          </div>

          <div className="row hub-pattern-card-row">
            <div className="hub-pattern-card-title">
              <span>
                <img src={gg} alt="" />
              </span>
              <h2>Browse Career Paths By Pattern</h2>
            </div>

            <div className="hub-pattern-card-outer">
              <div className="hub-pattern-cards">
                <div>
                  {" "}
                  <img src={cc} alt="" />
                </div>
                <div className="hub-pattern-cards-content">
                  <h5>Introvert Careers</h5>
                  <p>Roles that honor your independence and inner world.</p>
                  <a href="" class="new-commom-btn hub-banner-reveal">
                    <span>Explore</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </a>
                </div>
              </div>

              <div className="hub-pattern-cards">
                <div>
                  {" "}
                  <img src={cc} alt="" />
                </div>
                <div className="hub-pattern-cards-content">
                  <h5>Creative Careers</h5>
                  <p>Express your imagination and bring your ideas to life.</p>
                  <a href="" class="new-commom-btn hub-banner-reveal">
                    <span>Explore</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </a>
                </div>
              </div>

              <div className="hub-pattern-cards">
                <div>
                  {" "}
                  <img src={cc} alt="" />
                </div>
                <div className="hub-pattern-cards-content">
                  <h5>Analytical Careers</h5>
                  <p>
                    Use logic, data, and insight to solve problems that matter.
                  </p>
                  <a href="" class="new-commom-btn hub-banner-reveal">
                    <span>Explore</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </a>
                </div>
              </div>

              <div className="hub-pattern-cards">
                <div>
                  {" "}
                  <img src={cc} alt="" />
                </div>
                <div className="hub-pattern-cards-content">
                  <h5>Leadership Styles</h5>
                  <p>
                    Lead with authenticity and inspire others in your own way.
                  </p>
                  <a href="" class="new-commom-btn hub-banner-reveal">
                    <span>Explore</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </a>
                </div>
              </div>

              <div className="hub-pattern-cards">
                <div>
                  {" "}
                  <img src={cc} alt="" />
                </div>
                <div className="hub-pattern-cards-content">
                  <h5>Remote Work Fit</h5>
                  <p>
                    Find flexible roles that support your lifestyle and flow.
                  </p>
                  <a href="" class="new-commom-btn hub-banner-reveal">
                    <span>Explore</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </a>
                </div>
              </div>

              <div className="hub-pattern-cards">
                <div>
                  {" "}
                  <img src={cc} alt="" />
                </div>
                <div className="hub-pattern-cards-content">
                  <h5>Workplace Strengths</h5>
                  <p>
                    Discover your natural strengths and how to use them daily.
                  </p>
                  <a href="" class="new-commom-btn hub-banner-reveal">
                    <span>Explore</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row hub-pattern-popular">
            <div className="hub-pattern-card-title">
              <span>
                <img src={gg} alt="" />
              </span>
              <h2>From the Peek Blog</h2>
              <p>Insights and inspiration to help you build a career you love.</p>
            </div>

            <div className="hub-pattern-card-outer hub-pattern-card-outer-blog">
              <div className="hub-pattern-cards">
                <div>
                  {" "}
                  <img src={cc} alt="" />
                </div>
                <div className="hub-pattern-cards-content">
                  <h5>Introvert Careers</h5>
                  <p>Roles that honor your independence and inner world.</p>
                  <a href="" class="new-commom-btn hub-banner-reveal">
                    <span>Read Article</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </a>
                </div>
              </div>
              <div className="hub-pattern-cards">
                <div>
                  {" "}
                  <img src={cc} alt="" />
                </div>
                <div className="hub-pattern-cards-content">
                  <h5>Introvert Careers</h5>
                  <p>Roles that honor your independence and inner world.</p>
                  <a href="" class="new-commom-btn hub-banner-reveal">
                    <span>Read Article</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </a>
                </div>
              </div>
              <div className="hub-pattern-cards">
                <div>
                  {" "}
                  <img src={cc} alt="" />
                </div>
                <div className="hub-pattern-cards-content">
                  <h5>Introvert Careers</h5>
                  <p>Roles that honor your independence and inner world.</p>
                  <a href="" class="new-commom-btn hub-banner-reveal">
                    <span>Read Article</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </a>
                </div>
              </div>
              <div className="hub-pattern-cards">
                <div>
                  {" "}
                  <img src={cc} alt="" />
                </div>
                <div className="hub-pattern-cards-content">
                  <h5>Introvert Careers</h5>
                  <p>Roles that honor your independence and inner world.</p>
                  <a href="" class="new-commom-btn hub-banner-reveal">
                    <span>Read Article</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hub;
